import { Button, ButtonGroup, LuIcon, Text } from "@overmap-ai/blocks"
import { LngLat } from "mapbox-gl"
import { memo, useCallback } from "react"
import { useMap } from "react-map-gl/mapbox"

import { LocationCrosshair, MapSearchBar } from "../../mapbox/components"
import { useMapCenter } from "../../mapbox/hooks"
import { coordinatesToText } from "../../mapbox/utils"
import { modelIconMapping } from "../../mappings/icons"
import { BottomBar } from "../BottomBar/BottomBar"

interface LocationPickerOverlay {
	onConfirm: (coordinates: LngLat) => void
	onCancel: () => void
}

export const LocationPickerOverlay = memo<LocationPickerOverlay>((props) => {
	const { onConfirm, onCancel } = props

	const { current: map } = useMap()
	const center = useMapCenter(map)

	const handleConfirm = useCallback(() => {
		onConfirm(center)
	}, [center, onConfirm])

	return (
		<>
			<LocationCrosshair />
			<BottomBar className="flex flex-col gap-2">
				<div className="flex flex-col items-center gap-1">
					<Text align="center" size="sm">
						{coordinatesToText(center.toArray(), 6)}
					</Text>
					<Text size="xs" accentColor="base" weight="regular">
						Pan the map to position the marker or search
					</Text>
				</div>
				<MapSearchBar placeholder="Address or latitude, longitude" zoom={16.5} />
				<ButtonGroup className="grid w-full grid-cols-2 gap-2" size="sm" variant="soft">
					<Button onClick={onCancel} accentColor="base">
						<LuIcon icon={modelIconMapping.close} />
						Cancel
					</Button>
					<Button onClick={handleConfirm} variant="surface">
						<LuIcon icon={modelIconMapping.check} />
						Confirm
					</Button>
				</ButtonGroup>
			</BottomBar>
		</>
	)
})
LocationPickerOverlay.displayName = "LocationPickerOverlay"
